import { Divider, Loading } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import ContentConstants from '../../../contentConstants';
import { EditState, ISurveyQuestionEditModel } from '../../../models';
import { ErrorMessage, LoadingWrapper, Section, SectionHeaderContentWithCount } from '../../common';
import { IQuestionSectionProps } from './';
import { QuestionHasUpdatesUpdateAll } from './QuestionHasUpdatesUpdateAll';
import { QuestionHasUpdatesWarning } from './QuestionHasUpdatesWarning';
import { QuestionSectionContent } from './QuestionSectionContent';

export class QuestionSection extends React.Component<IQuestionSectionProps> {
	public getActiveQuestions(questions: ISurveyQuestionEditModel[]) {
		return questions.filter((q: ISurveyQuestionEditModel) => q.isActive && q.editState !== EditState.Remove);
	}

	public getErrorMessage() {
		return ContentConstants.ERROR_QUESTION_LIMIT.replace('{threshold}', this.props.selectionThreshold + '');
	}

	public getSectionHeaderContent(activeQuestions: ISurveyQuestionEditModel[]) {
		return (
			<SectionHeaderContentWithCount
				text={this.props.sectionHeaderText}
				count={activeQuestions.length}
				threshold={this.props.selectionThreshold}
			/>
		);
	}

	public render() {
		const {
			isQuestionChangesLoading,
			questions,
			selectionThreshold,
			openDemographicQuestionModal,
			openCustomDemographicQuestionsModal,
			openQuestionModal,
			openCustomModal,
		} = this.props;
		const activeQuestions = this.getActiveQuestions(questions);
		const surveyQuestions = activeQuestions.filter((aq) => !aq.isDemographic);
		const demographicQuestions = activeQuestions.filter((aq) => aq.isDemographic);
		const questionHasUpdates = _.filter(questions, (q) => q.hasUpdates);

		return (
			<Section id={'survey-questions'} sectionHeader={this.getSectionHeaderContent(activeQuestions)}>
				<ErrorMessage message={this.getErrorMessage()} showIcon={true} show={activeQuestions.length > selectionThreshold} />
				{questions.length > 0 && questionHasUpdates.length > 0 && (
					<>
						<QuestionHasUpdatesWarning />
						<QuestionHasUpdatesUpdateAll questions={questions} />
						<Divider type='dashed' />
					</>
				)}
				{isQuestionChangesLoading ? (
					<>
						<LoadingWrapper>
							<Loading height={'70px'} width={'70px'} />
						</LoadingWrapper>
					</>
				) : (
					<>
						<QuestionSectionContent
							{...this.props}
							questions={surveyQuestions}
							textLabel={ContentConstants.TITLE_SURVEY_QUESTIONS}
							instructionalText={ContentConstants.INSTRUCTIONALTEXT_ADD_SURVEY_CONTENT}
							manageCustomButtonText={ContentConstants.BUTTONS_MANAGE_CUSTOM}
							openModal={openQuestionModal}
							openCustomModal={openCustomModal}
							clickboxText={ContentConstants.BUTTONS_ADD_SURVEY_QUESTIONS}
							includeDimensions={true}
							isDemographic={false}
						/>
						<Divider type='dashed' />
						<QuestionSectionContent
							{...this.props}
							questions={demographicQuestions}
							textLabel={ContentConstants.TITLE_DEMOGRAPHIC_QUESTIONS}
							instructionalText={ContentConstants.INSTRUCTIONALTEXT_ADD_DEMOGRAPHIC_QUESTIONS}
							manageCustomButtonText={ContentConstants.BUTTONS_MANAGE_CUSTOM}
							openModal={openDemographicQuestionModal}
							openCustomModal={openCustomDemographicQuestionsModal}
							clickboxText={ContentConstants.BUTTONS_ADD_DEMOGRAPHIC_QUESTIONS}
							includeDimensions={false}
							isDemographic={true}
						/>
					</>
				)}
			</Section>
		);
	}
}
